import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

export function ForbiddenPage() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Card style={{ maxWidth: 480 }}>
        <CardBody className="text-center">
          <h2 className="mb-3">403 · Keine Berechtigung</h2>
          <p className="text-muted">Dein Permission-Set deckt diese View nicht ab.</p>
          <Link to="/">Zurück zur Startseite</Link>
        </CardBody>
      </Card>
    </div>
  );
}
